import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from "react-router-dom";

import { Button, Tabs, Alert  } from "flowbite-react";
import { HiAdjustments, HiClipboardList, HiUserCircle  } from "react-icons/hi";
import { Table, TableBody, TableCell, TableHead, TableHeadCell, TableRow } from "flowbite-react";
import { PencilSquareIcon, ArrowUpTrayIcon, ListBulletIcon } from '@heroicons/react/24/outline'
import { MdDashboard, MdOutlineAttachFile  } from "react-icons/md";
import axios from 'axios';
import LoadingSpinner from '../../components/LoadingSpinner';

const content = ({solutionId,onClose,solutionName}) => {

    const [types, setTypes] = useState([]);    
    const [restriccion, setRestriccion] = useState(null);
    const fileInputRef = useRef(null);
    const [contents, setContents] = useState([]);
    const [solutionIdProp, setSolutionIdProp] = useState("");
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const [formComplemento, setFormComplemento] = useState({
        folderName: "documentacion",
        prefixFile: Date.now() + "-" + Math.round(Math.random() * 1e9),
        doc_tipo: "",
        doc_title: "",
        doc_solutionid: solutionId,
        doc_file: "",
      });

    const handleInputComplementoChange = (e) => {
        const validaSelect = (e.target.selectedOptions)?e.target.selectedOptions[0]:null;
        const selectedOption = validaSelect?.getAttribute("data-restriccion");
        setRestriccion((selectedOption)?selectedOption:null);

        const { name, value } = e.target;
        setFormComplemento({ ...formComplemento, [name]: value });
    };

    const handleFileComplementoChange = (e) => {
        const { name, files } = e.target;
        setFormComplemento({ ...formComplemento, [name]: files[0] });
    };

    const handleCancelComplemento = () => {
        setFormComplemento((prevState) => ({
            ...prevState, // Mantiene el valor actual de doc_solutionid
            doc_tipo: "",
            doc_title: "",
            folderName: "documentacion",
            prefixFile: Date.now() + "-" + Math.round(Math.random() * 1e9)
        }));
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        //setFormComplemento({ ...formComplemento, "doc_solutionid" : solutionId });
    };

    const handleSubmitComplement = async () => {
        setIsLoading(true);
        try {
          //setFormComplemento({ ...formComplemento, "doc_solutionid" : solutionIdProp });
    
          const response = await axios.post(
            `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/content/create`,formComplemento,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
          });

          if(response.data.status){
            if (response.data.queued) {
              alert(response.data.message || "Video en procesamiento interno");
            } else {
              alert("Archivo cargado correctamente");
            }
            setContents((contents) => [...contents, response.data.content]);
            handleCancelComplemento();
            
          }else{
            alert("Problema al cargar el archivo intenta nuevamente");
          }
        } catch (error) {
          
        } finally{
            setIsLoading(false);
          }
    }

    const handleRemoveContent = async(idContent) => {
        setIsLoading(true);
        try {
            const response = await axios.delete(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/content/${idContent}/delete`,
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if(response.data.status){
              alert("Archivo eliminado correctamente "+response.data.e);
              setContents(contents.filter((co) => co.id !== response.data.content.id));
              handleCancelComplemento();
              
            }else{
              alert("Problema al eliminar el archivo intenta nuevamente");
              
            }
          } catch (error) {
            
          } finally{
            setIsLoading(false);
          }

    }
    const handleFinish = () => {
        const confirma = confirm('Desea terminar el proceso de carga de la solución ?');
        if (!confirma) return;
    
        handleCancelComplemento();
        onClose(false);
        setContents([]);
    
        navigate(`./solucion/${solutionIdProp}/view`);
      }

    useEffect(()=>{
        const getContentType = async () => {
            setIsLoading(true);
            try {
              const response = await axios.get(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/content_types`,
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
              setTypes(response.data);
            } catch (error) {
                
            } finally{
                setIsLoading(false);
              }
          }

        const getUploadFiles = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(
                  `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/contentBySolution/${solutionId}`,
                  {
                    withCredentials: true,
                      headers: {
                          "Content-Type": "multipart/form-data",
                      },
                  });
                setContents(response.data);
              } catch (error) {

              } finally{
                setIsLoading(false);
              }
        }

        getUploadFiles();
        getContentType();
        if(solutionId){
            setSolutionIdProp(solutionId);
            setFormComplemento({ ...formComplemento, "doc_solutionid" : solutionId });
        }
        
    },[solutionId]);

  return (
    <>
       {isLoading && <LoadingSpinner message="Procesando..." size="lg" color="blue"/>}
        <div>
            <Alert
            color="success"
            className='mb-2'>
                <label className="block text-lg font-medium text-gray-900 dark:text-white">{solutionName}</label>
            </Alert>

            <div className='lg:flex'>
            <div className='flex-col'>
                <input type="hidden" name="doc_solutionid" onChange={handleInputComplementoChange} value={solutionIdProp}/>
                <input type="hidden" name="folderName" onChange={handleInputComplementoChange} value={formComplemento.folderName}/>      
                <input type="hidden" name="prefixFile" onChange={handleInputComplementoChange} value={formComplemento.prefixFile}/>   
                <div>
                <label htmlFor="doc_tipo" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Tipo</label>
                <select  
                    name="doc_tipo" 
                    id="doc_tipo" 
                    value={formComplemento.doc_tipo}
                    onChange={handleInputComplementoChange}
                    aria-describedby="helper-text-explanation" 
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                    >
                        <option value="">Seleccione Tipo</option>
                        {types.map((type) => (
                        <option key={type.id} value={type.id} data-restriccion={type.type}>{type.name}</option>
                        ))}
                    </select>
                </div>

                <div>
                <label htmlFor="doc_title" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Titulo</label>
                <input
                    type="text"
                    name="doc_title"
                    value={formComplemento.doc_title}
                    onChange={handleInputComplementoChange}
                    aria-describedby="helper-text-explanation" 
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                    
                />
                </div>
                

                <div>
                <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Cargar Archivo</label>
                <input
                    type="file"
                    name="doc_file"
                    accept={restriccion}
                    ref={fileInputRef}
                    onChange={handleFileComplementoChange}
                    aria-describedby="helper-text-explanation" 
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                
                />
                </div>
                
                

            </div>
            <div className='lg:p-2 mt-6 lg:mt-0'>
                <label className="uppercase block mb-2 text-sm font-medium text-gray-900 dark:text-white">Archivos cargados</label>

                <div className="overflow-x-auto">
                    <Table>
                    <Table.Head>
                        <Table.HeadCell>Tipo</Table.HeadCell>
                        <Table.HeadCell>Titulo</Table.HeadCell>
                        <Table.HeadCell>Acción</Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="divide-y">
                        {contents.map((file) => (
                        <Table.Row key={file.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                            <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                            {(file.Content_type)?file.Content_type.name:file.content_type_name }
                            </Table.Cell>
                            <Table.Cell>{file.name}</Table.Cell>
                            <Table.Cell>
                                <a href="#" onClick={() => handleRemoveContent(file.id)} className="font-medium text-cyan-600 hover:underline dark:text-cyan-500">
                                    Borrar
                                </a>
                            </Table.Cell>
                        </Table.Row>
                        ))}
                        
                        
                    </Table.Body>
                    </Table>
                </div>  

                        
            </div>

            
            </div>
            <div className='lg:flex'>
            <div className='flex-col w-full lg:w-1/2'>
                <div className="flex justify-between mt-4">
                    <button
                    type="button"
                    onClick={handleCancelComplemento} 
                    className="bg-gray-200  px-4 py-2 rounded"
                    >
                    Cancelar
                    </button>
                    <button
                    type="button"
                    onClick={handleSubmitComplement}
                    className="bg-green-400 px-4 py-2 rounded"
                    >
                    Guardar
                    </button>
                </div>
            </div>
            <div className='flex-col w-full lg:w-1/2'>
                <div className="flex justify-between m-4">
                <button
                    type="button"
                    onClick={handleFinish}
                    className="bg-gray-100 px-4 py-2 rounded w-full"
                >
                    Finalizar
                </button>
                </div>  
            </div>
            </div>
        </div>
        
    </>
  )
}

export default content
